import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { DiseaseMedical } from 'src/app/_models';
import { HttpClient } from '@angular/common/http';


@Injectable({
  providedIn: 'root'
})
export class DiseaseMedicalService {
  url: string;
  getByTypeUrl: string;
  addUrl: string;
  deleteUrl: string;
  updateUrl: string;
  getAllUrl: string;
  addUserDiseaseUrl: string;
  deleteUserDiseaseUrl: string;
  getUserDiseaseMedicalUrl: string;
  constructor(private http: HttpClient) {
    this.url = `${environment.apiUrl}DiseaseMedication/`;
    this.getByTypeUrl = `${this.url}GetByType`;
    this.addUrl = `${this.url}Add`;
    this.updateUrl = `${this.url}Update`;
    this.deleteUrl = `${this.url}Delete`;
    this.getAllUrl = `${this.url}GetAll`;
    this.addUserDiseaseUrl = `${this.url}AddUserDiseaseMedication`;
    this.deleteUserDiseaseUrl = `${this.url}DeleteUserDisease`;
    this.getUserDiseaseMedicalUrl = `${this.url}GetUserDiseasesIdsByUserId`;
  }

  add(data: DiseaseMedical) {
    return this.http.post(this.addUrl, data);
  }

  delete(medicalDiseasId: number) {
    return this.http.delete(`${this.deleteUrl}/${medicalDiseasId}`);
  }

  update(data: DiseaseMedical) {
    return this.http.put(this.updateUrl, data);
  }

  getByType(typeId: number) {
    return this.http.get(`${this.getByTypeUrl}/${typeId}`);
  }

  getAll() {
    return this.http.get(this.getAllUrl);
  }

  // user disease 
  addUserDisease(data) { 
    return this.http.post(this.addUserDiseaseUrl, data);
  }

  getUserDiseaseMedical(userId:string) {
    return this.http.get(`${this.getUserDiseaseMedicalUrl}/${userId}`);
  }
  
  deleteUserDiseaseMediacl(userId: string, diseaseMedicalId: number) { 
    return this.http.delete(`${this.deleteUserDiseaseUrl}/${userId}/${diseaseMedicalId}`);
  }
}
